import axioInstance from "@/libs/axios";
import {
  WithdrawalPolicyResponse,
  WithdrawalRequestPayload,
} from "@/types/withdrawal";

const submitWithdrawalRequest = async (
  policyReference: string,
  payload: WithdrawalRequestPayload
): Promise<WithdrawalPolicyResponse> => {
  const result = await axioInstance.post<WithdrawalPolicyResponse>(
    `/policy/${policyReference}/withdrawal/request`,
    payload
  );
  return result.data;
};

export default submitWithdrawalRequest;
